export  default {
    setPermOperators(state, payload) {
        state.permOperators = payload;
      },
    setPermOperator(state, payload) {
        state.permOperator = payload;
      },
   
};